import type { GetServerSideProps, NextPage } from 'next';
import { z } from 'zod';
import { modularPageWrapperSchema } from '../../components/ModularPageWrapper/schema';
import { getCachedEntryByUrl } from '../../utils/requests/contentstack/cachedRequests';
import { formatError, serverLogger } from '../../utils/loggers/server';
import { ModularPageWrapper } from '../../components/ModularPageWrapper';

export type KidsPageProps = z.infer<typeof modularPageWrapperSchema>;

export const getServerSideProps: GetServerSideProps<KidsPageProps> = async ({
  locale,
}) => {
  try {
    const entryResponse = await getCachedEntryByUrl({
      contentType: 'modular_page',
      url: '/kids-onboarding-vision',
      language: locale,
      schema: modularPageWrapperSchema,
      logger: serverLogger,
    });

    return {
      props: {
        seoData: entryResponse.data.seoData,
        modules: entryResponse.data.modules,
      },
    };
  } catch (error: unknown) {
    serverLogger({
      level: 'error',
      team: 'client-onboarding',
      message: 'Required page data is undefined - Kids',
      context: {
        error: formatError(error),
        page: '/kids',
        severity: 'critical',
      },
    });

    throw new Error('Required data not provided to render Kids page');
  }
};

const KidsPage: NextPage<KidsPageProps> = ({ seoData, modules }) => {
  return <ModularPageWrapper seoData={seoData} modules={modules} />;
};

export default KidsPage;
